






































import {Component, Vue, Prop} from 'vue-property-decorator';
import {PModuleWithMeasurements, PModuleEvent} from '@/views/system/modules/interfaces';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import Loading from '@c/controls/Loading.vue';
import {DBRecordsTableHeader} from '@/views/system/modules/interfaces';
import {getFormattedDate} from '@/utils/dateTimeUtils';

@Component({
  components: {Loading},
})
export default class TableLastDBRecords extends Vue {
  // Программный модуль
  @Prop()
  pmodule!: PModuleWithMeasurements;

  // хранилище
  @Prop()
  apiStore!: PModuleStoreModule;

  // Событие
  @Prop()
  event!: PModuleEvent;

  headers: DBRecordsTableHeader[] = [];
  items: any[] = [];

  //Количество последних записей, получаемых с сервера
  limit = 10;

  error = false;
  loading = true;

  async loadData() {
    this.error = false;
    this.loading = true;
    try {
      const records = await this.apiStore.getLastEvents({
        id: this.pmodule?.id as number,
        eventType: this.event?.type,
        limit: this.limit,
      });

      records[1].forEach((header: any) => {
        this.headers.push({text: header[0], value: header[0], sortable: false});
      });

      this.items = records[0].map((values: any[]) => {
        const row: {[key: string]: any} = {};
        values.forEach((v, index) => {
          row[this.headers[index].value] = v;
        });
        return row;
      });

      const index = this.headers.findIndex((header: any) => header.value === 'timestamp');
      if (index !== -1) {
        this.headers.splice(index + 1, 0, {text: 'date', value: 'date', sortable: false});
        this.items = this.items.map((item: any) => {
          return {
            ...item,
            date: getFormattedDate(item.timestamp, 'dd.MM.yyyy HH:mm:ss,SSS'),
          };
        });
      }
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async created() {
    this.loadData();
  }

  reload() {
    this.headers = [];
    this.items = [];
    this.loadData();
  }
}
